import { deleteApiAuthLogout, usePostApiUserChangePassword } from "@/API";
import { ResetPasswordForm } from "@/Forms/PasswordScheme";
import { useAuthStore } from "@/Stores/AuthStore";
import { Modal } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useNavigate } from "@tanstack/react-router";
import { AxiosError } from "axios";

export function ChangePasswordDialog(props: { opened: boolean, onClose: () => void }) {
    const auth = useAuthStore();
    const navigate = useNavigate()
    const changePassword_Mutation = usePostApiUserChangePassword()

    return <>
        <Modal opened={props.opened} onClose={props.onClose} title="修改密碼">
            <ResetPasswordForm onSubmit={async data => {
                auth.SetUpdating(true)
                try {
                    await changePassword_Mutation.mutateAsync({
                        data: {
                            oldPassword: data.oldPassword,
                            newPassword: data.newPassword
                        }
                    })
                    var result = await deleteApiAuthLogout()
                    auth.Reset()
                    notifications.show({ message: "修改密碼成功，請重新登入" })
                    navigate({ to: "/" })
                    props.onClose()
                } catch (e) {
                    const error = e as AxiosError
                    if (error.code = "401")
                        notifications.show({ message: "舊密碼輸入錯誤", color: "red" })
                    else
                        notifications.show({ message: "修改失敗", color: "red" })
                }
                auth.SetUpdating(false)
            }} />
        </Modal>
    </>
}